import { OptionsContainer } from '@aibees/elephant/feature/suggestion-search-bar/components/options-container';
import { useSuggestionSearchBarContext } from '@aibees/elephant/feature/suggestion-search-bar/context';
import { classnames } from '@aibees/shared/utils';
import { useTheme } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PopoverProps as Props } from './types';

export const Popover = memo(({ className, width }: Props) => {
  const { popupOpen, renderMode } = useSuggestionSearchBarContext();
  const theme = useTheme();

  const dialogMode = renderMode === 'dialog';

  const popoverHeight = popupOpen || dialogMode ? theme.spacing(42.5) : '0';

  return (
    <Styled.Wrapper
      className={classnames('Popover', className)}
      sx={SX.root({ width, dialogMode, popoverHeight })}
    >
      <OptionsContainer />
    </Styled.Wrapper>
  );
});

Popover.displayName = 'Popover';
